import request from '@/utils/request'
import axios from 'axios'

// 上传文件到七牛云获取token
export function uploadToken() {
  return request({
    url: '/upload/token/v1'
  })
}

// 上传文件到七牛云
export function uploadFileToQiniu(data) {
  return request({
    baseURL: 'https://up-z0.qiniup.com',
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data' // 针对文件上传的请求头
    },
    data
  })
}

// 上传文件获取进度条
export function uploadFile(data, config) {
  let axiosConfig = {
    baseURL: 'https://up-z0.qiniup.com',
    method: 'POST',
    data
  }
  if (config instanceof Object) {
    for (let key in config) {
      axiosConfig[key] = config[key]
    }
  }
  return axios(axiosConfig)
}

// 商品图片智能抠图
export function imageCut(imageFile) {
  const formData = new FormData()
  formData.append('image_file', imageFile)
  formData.append('type', 'whiteBK')
  return request({
    url: '/urlCommoditSegmenter/segmentByFile/v1',
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

// 下载缓存区
export function getFileDownList(params) {
  return request({
    url: '/export_file_download/v1',
    params
  })
}

export function deleteFile(id) {
  return request(
    {
      url: `/export_file_download/${ id }/v1`,
      method: 'DELETE'
    },
    {
      successTip: true,
      successMsg: '删除成功'
    }
  )
}

export function shopList(params) {
  return request({
    url: '/mct_shop/v1',
    params
  })
}

// 单位系统字典列表
export function sysDicListApi(module) {
  return request({
    url: '/sys_dic/v2',
    params: {
      module
    }
  })
}

// 设备型号
export function modelList(params) {
  return request({
    url: '/customer_center_model/v1',
    params
  })
}

// 获取apk md5
export function getFileMd5(down_url) {
  return request({
    baseURL: `${ down_url }?qhash/md5`
  })
}

// 获取菜单栏待处理数量
export function getWaitCount() {
  return request({
    url: '/repertory_management/alert/menu/v1'
  })
}

// 商品分类列表
export function categoryList(params) {
  return request({
    url: '/goods_category/getListByName',
    params
  })
}

// 商品品牌列表
export function goodsBrandList(params) {
  return request({
    url: '/goods_brand/v1',
    params
  })
}

// 阿里云上传
export function alibabaCloudUpload(params) {
  return request({
    url: '/sts_upload/token/v1',
    method: 'GET',
    params
  })
}

/* 获取组织 */
export function getOrgsList() {
  return request({
    url: '/mct_org/all/v1',
    params
  })
}

// 查询省编码列表
export function getSysAreaCode() {
  return request({
    url: '/sys_area_code/v1'
  })
}

// 查询市编码列表
export function getSysCityCode(provCode) {
  return request({
    url: `/sys_area_code/${ provCode }/v1`
  })
}

// 查询区编码列表
export function getSysDistCode() {
  return request({
    url: `/sys_area_code/city_code_list/${ cityCode }/v1`
  })
}

/* 获取当前账号组织树形结构查询数据 */
export function getTreeList(params) {
  return request({
    url: `/mct_org/tree/v1`,
    params
  })
}

// 货柜型号
export function cabinetModelList(params) {
  return request({
    url: '/device_cabinet_model/v1',
    params
  })
}

//
export function cabinetModelListV2(params) {
  return request({
    url: '/goods_tmpl/v2',
    params
  })
}

// 店铺场景值列表
export function sceneInfoList(params) {
  return request({
    url: '/scene_info/v1',
    params
  })
}

// 操作人列表
export function getOperationList(params) {
  return request({
    url: '/worker/operator/v1',
    params
  })
}

// 获取动态表单
export function getDynamicForm(params) {
  return request({
    url: '/manager_forms/v1',
    params
  })
}

// 传入动态表单
export function setDynamicForm(data) {
  return request({
    url: '/manager_forms/v1',
    method: 'PUT',
    data
  })
}

/* 订单角标(待处理数量) */
export function getOrderBadge() {
  return request({
    url: `/order/type_count`
  })
}
